import React, {
    Fragment, useCallback, useState, useContext, useRef,useEffect
} from 'react';
import _, { isNull, isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication, RedirectAfterLogin, AUTH_ERRORS } from 'gw-digital-auth-react';
import { Loader } from '@jutro/components';
import { isEmpty } from '../LoginUtil';

import messages from './LoginComponent.messages';
import metadata from './LoginComponent.metadata.json5';
import styles from '../CommonLogin.module.scss';
import {getImageSrc} from './../../../utils/lobIconUtil';


function LoginComponent(props) {
    const {
        onForgotPassword, successPath, loginPath, pathAfterSignIn, onHandleShowSignup,onRegister
    } = props;
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const [loginError, updateLoginError] = useState('');
    const [isSignInButtonClicked, setSignInButtonClicked] = useState(false);
    const [issendVerifyButtonClicked, setSendVerifyButtonClicked] = useState(false);
    const { login: authLogin, isAuthInProgress, getXUaaCsrf } = useAuthentication();
    const { sendVerifyCode, verifyCodeReceived } = useAuthentication();
    const signInRef = useRef({});
    const [isLoginInProgress, setLoginInProgress] = useState(false);
    const [phoneNumber, updatePhoneNumber] = useState('');
    const [email, updateEmail] = useState('');
    const [selectedType, updateSelectedType] = useState('');
    const auth = useAuthentication();

    useEffect(() => {
        const timeout = setTimeout(() => {
          const input = document.querySelector('input[name="codeReceived"]');
          if (input && input.value && input.value !== formData.codeReceived) {
            handleCodeReceivedChange(input.value);
          }
        }, 1000); // delay to allow Safari to autofill
      
        return () => clearTimeout(timeout);
      }, []);

    const login = useCallback(() => {
        const username = _.get(formData, 'username');
        const password = _.get(formData, 'password');
        const codeEntered = _.get(formData, 'codeReceived');

        setLoginInProgress(true);
        if (isEmpty(username) || isEmpty(password)) {
            updateLoginError('fieldEmpty');
            return Promise.resolve();
        }
        if(isUndefined(codeEntered) || isNull(codeEntered)|| isEmpty(codeEntered) || isEmpty(codeEntered.trim())){
            updateLoginError('fieldUndefined');
            return Promise.resolve();
        }
        const codeReceived = codeEntered.trim();
        if (codeReceived.length < 6 || codeReceived.length > 6 || isNaN(codeReceived)) {
            updateLoginError('invalidCode');
            return Promise.resolve();
        }

        updateLoginError(''); // reset errors

        return authLogin({
            username: username,
            password: password,
            codeReceived: codeReceived,
            verificationMode: selectedType
        })
            .then(() => {
                // reset errors
                updateLoginError('');
                setLoginInProgress(false);
                // Force user to logout after 10 hours incase the same session is being used
                const closeTimer = setTimeout(() => {
                    auth.logout();
                },
                1000 * 60 * 60 * 10);
                // window.clearTimeout(closeTimer);
            })
            .catch((err) => {
                setLoginInProgress(false);
                switch (_.get(err, 'error')) {
                    case AUTH_ERRORS.login_failure: // credentials are wrong
                    case AUTH_ERRORS.notLoggedIn: // tokens check problem
                        updateLoginError('fieldsIncorrect');
                        break;
                    case AUTH_ERRORS.account_locked: {
                        // account is locked
                        updateLoginError('accountLocked');
                        break;
                    }
                    case AUTH_ERRORS.invalidVerificationCode: {
                        // Invalid verification code is entered
                        updateLoginError('invalidVerificationCode');
                        break;
                    }
                    default:
                        updateLoginError('invalidAttempt');
                        break;
                }
            });
    }, [authLogin, formData]);

    const sendVerificationCode = useCallback(() => {
        const username = _.get(formData, 'username');
        const password = _.get(formData, 'password');
        //console.log(selectedType);
        if (selectedType === '' && (isEmpty(username) || isEmpty(password))) {
            updateLoginError('fieldEmpty');
            return Promise.resolve();
        }
        updateLoginError(''); // reset errors

        getXUaaCsrf().then((csrfToken) => {
            return sendVerifyCode({
                givenName: 'user',
                familyName: 'name',
                userName: username,
                email: 'user@name.com',
                password: password,
                verificationMode: selectedType,
                xUaaCsrf: csrfToken
            })
                .then((resp) => {
                    // updateSelectedType('phoneMode');
                    updateSelectedType(selectedType);
                    updatePhoneNumber(resp);
                    setSignInButtonClicked(true);
                    if (selectedType !== '') {
                        setSendVerifyButtonClicked(true);
                    }
                    onHandleShowSignup();
                })
                .catch((err) => {
                    setLoginInProgress(false);
                    switch (_.get(err, 'error')) {
                        case AUTH_ERRORS.login_failure: // credentials are wrong
                        case AUTH_ERRORS.notLoggedIn: // tokens check problem
                            updateLoginError('fieldsIncorrect');
                            break;
                        case AUTH_ERRORS.account_locked: {
                            // account is locked
                            updateLoginError('accountLocked');
                            break;
                        }
                        default:
                            updateLoginError('invalidAttempt');
                            break;
                    }
                });
        });
    }, [formData, selectedType, getXUaaCsrf, sendVerifyCode, onHandleShowSignup]);

    const verifyVerificationCode = useCallback(() => {
        const codeReceived = _.get(formData, 'codeReceived');

        if (isEmpty(codeReceived)) {
            updateLoginError('fieldEmpty');
            return Promise.resolve();
        }

        updateLoginError(''); // reset errors

        return verifyCodeReceived({
            codeReceived
        })
            .then((resp) => {
                console.log(resp);
                login();
            })
            .catch((err) => {
                console.log(err);
            });
    }, [verifyCodeReceived, formData]);

    const getAvailableValues = () => {
        const username = _.get(formData, 'username');
        const str = username !== undefined ? username.split('') : [];
        let finalArr = [];
        const len = str.indexOf('@');
        str.forEach((item,pos)=>{
            (pos>=1 && pos<=len-2) ? finalArr.push('*') : finalArr.push(str[pos]);
        });
        const maskedEmail = finalArr.join('');
        const addressOptionsArray = [
            {
                code: 'phoneMode',
                name: translator(messages.phoneModeText, { num: phoneNumber })
            },
            {
                code: 'emailMode',
                name: translator(messages.emailModeText, { num: maskedEmail })
            }
        ];
        return addressOptionsArray;
    };

    const handleCodeReceivedChange = (value) => {
        updateFormData((prevData) => ({
          ...prevData,
          codeReceived: value,
        }));
    };
    
    const updateVerifiactionValue = (value) => {
        console.log(value);
        updateSelectedType(value);
    };

    const readValue = useCallback(
        (id, path) => {
            return _.get(formData, path);
        },
        [formData]
    );

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    const handleEnterKey = () => {
        signInRef.current.click();
    };
    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    // const isSafariMobile =() =>{
    //     const ua = navigator.userAgent;
    //     return /iP(hone|od|ad)/.test(ua) && /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS/.test(ua);
    // }

    const overrideProps = {
        '@field': {
            onValueChange: writeValue,
            onEnter: handleEnterKey
        },
        signIn: {
            trigger: sendVerificationCode,
            innerRef: signInRef
        },
        verifyCode: {
            trigger: login,
            innerRef: signInRef
        },
        sendVerifyCode: {
            trigger: sendVerificationCode,
            innerRef: signInRef
        },
        linkToForgotPassword: {
            visible: !_.isUndefined(onForgotPassword),
            className: styles.forgotPassword
        },
        actionsWrapperButtonContainer: {
            
            visible: isSignInButtonClicked !== true && issendVerifyButtonClicked !== true,
        },
        errorMsg: {
            content: translator(messages[loginError]),
            visible: !!loginError,
            role: 'alert',
            tabIndex: !!loginError ? '0' : '-1'
        },
        heading:{
            src: getImageSrc("branding/New-OptimLogo.png")
        },
        loginForm: {
            visible: isSignInButtonClicked !== true && issendVerifyButtonClicked !== true
        },
        actionsWrapperSingleLink: {
            visible: isSignInButtonClicked !== true && issendVerifyButtonClicked !== true
        },
        verifyForm: {
            visible: isSignInButtonClicked === true && issendVerifyButtonClicked === true
        },
        actionsWrapperSingleVerifyButton: {
            visible: isSignInButtonClicked === true && issendVerifyButtonClicked === true
        },
        /*codeReceived: {
            label: !_.isEmpty(phoneNumber) ? translator(messages.verificationText, { num: phoneNumber }) : translator(messages.verificationTextOnEmail)
        },*/
        codeReceived: {

            label: selectedType === 'emailMode'? translator(messages.verificationTextOnEmail): translator(messages.verificationText),
           value: formData.codeReceived || '',
            onValueChange: (e) => handleCodeReceivedChange(e),
            onInput: (e) => handleCodeReceivedChange(e),
            // innerRef: signInRef,
            // inputProps: isSafariMobile() ? {
            //   autoComplete: 'off',
            //   autoCorrect: 'off',
            //   spellCheck: false,
            //   inputMode: 'numeric',
            //   name: 'userInputTokenField', // use a nonstandard name
            //   'aria-autocomplete': 'none'
            // } : {}
          
        },
        actionsWrapperVerifySingleLink: {
            visible: isSignInButtonClicked === true && issendVerifyButtonClicked === true
        },
        mobileOrEmailRadioButton: {
            availableValues: getAvailableValues(),
            value: selectedType
        },
        selectMobileOrEmail: {
            visible: isSignInButtonClicked === true && issendVerifyButtonClicked !== true
        },
        loginButtonContainer: {
            
            visible: isSignInButtonClicked !== true && issendVerifyButtonClicked !== true,
        },
        signUpContainer: {
            
            visible: isSignInButtonClicked !== true && issendVerifyButtonClicked !== true,
        },
    };

    const resolvers = {
        resolveValue: readValue,
        resolveCallbackMap: {
            login: login,
            forgotPassword: onForgotPassword || _.noop,
            sendVerificationCode: sendVerificationCode,
            resentVerificationCode: sendVerificationCode || _.noop,
            updateVerifiactionValue: updateVerifiactionValue,
            clickToRegister: onRegister
        },
        resolveClassNameMap: styles
    };

    const successRedirectPath = isSignInButtonClicked ? pathAfterSignIn : successPath;

    return (
        <Fragment>
            <RedirectAfterLogin successPath={successRedirectPath} loginPath={loginPath} />
            {renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers)}
        </Fragment>
    );
}

LoginComponent.propTypes = {
    onForgotPassword: PropTypes.func,
    successPath: PropTypes.string,
    loginPath: PropTypes.string,
    pathAfterSignIn: PropTypes.string,
    onHandleShowSignup: PropTypes.func,
};

LoginComponent.defaultProps = {
    onForgotPassword: undefined,
    successPath: undefined,
    loginPath: undefined,
    pathAfterSignIn: undefined,
    onHandleShowSignup: undefined
};

export default LoginComponent;
